/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-01 14:59:02
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

async function getPublicInf (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _getPublicInf(id, User.res.customer).then((res) => {
          resolve(res.data.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 获取商家公众号信息
 */
function _getPublicInf (id, customer) {
  const url = `/v1/front/wx_account`
  return axios({
    method: 'GET',
    url: url
  })
}

export {getPublicInf}



// WEBPACK FOOTER //
// ./src/api/getPublicInf.js